import React from 'react';

const VideoTutorialIcon= ({size,color}) => {
  return (
 <>
 <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 0.96 0.96" fill="none">
<path d="M0.81 0.12H0.15a0.09 0.09 0 0 0 -0.09 0.09v0.54a0.09 0.09 0 0 0 0.09 0.09h0.66a0.09 0.09 0 0 0 0.09 -0.09V0.21a0.09 0.09 0 0 0 -0.09 -0.09" fill="#e9e9e9"/>
<path d="M0.75 0.72H0.21a0.03 0.03 0 0 1 0 -0.06h0.54a0.03 0.03 0 0 1 0 0.06" fill="#222"/>
<path d="M0.57 0.75a0.03 0.03 0 0 1 -0.03 -0.03v-0.06a0.03 0.03 0 0 1 0.06 0v0.06a0.03 0.03 0 0 1 -0.03 0.03" fill="#222"/>
<path d="m0.613 0.38 -0.21 -0.105a0.03 0.03 0 0 0 -0.043 0.027v0.236a0.03 0.03 0 0 0 0.016 0.026 0.027 0.027 0 0 0 0.014 0.004 0.03 0.03 0 0 0 0.016 -0.004l0.21 -0.131a0.03 0.03 0 0 0 -0.002 -0.052" fill="#222"/>
<path d="M0.15 0.12a0.09 0.09 0 0 0 -0.09 0.09v0.54a0.09 0.09 0 0 0 0.09 0.09h0.33V0.12z" fill="#e9e9e9"/>
<path d="M0.21 0.66a0.03 0.03 0 0 0 0 0.06h0.27v-0.06z" fill="#222"/>
<path d="M0.403 0.275a0.03 0.03 0 0 0 -0.043 0.027v0.236a0.03 0.03 0 0 0 0.016 0.026 0.027 0.027 0 0 0 0.014 0.004 0.03 0.03 0 0 0 0.016 -0.004L0.48 0.517v-0.204z" fill="#222"/>
<path d="M0.81 0.12H0.15a0.09 0.09 0 0 0 -0.09 0.09v0.54a0.09 0.09 0 0 0 0.09 0.09h0.66a0.09 0.09 0 0 0 0.09 -0.09V0.21a0.09 0.09 0 0 0 -0.09 -0.09m0.03 0.63a0.03 0.03 0 0 1 -0.03 0.03H0.15a0.03 0.03 0 0 1 -0.03 -0.03V0.21a0.03 0.03 0 0 1 0.03 -0.03h0.66a0.03 0.03 0 0 1 0.03 0.03z" fill="#263238"/>
</svg>
 </>
  );
};
VideoTutorialIcon.defaultProps = {
  size: 16,
  color:'#5453D2'
};
export default VideoTutorialIcon